import { render } from "./ErrorBasic.vue?vue&type=template&id=5f603e95&scoped=true"
import script from "./ErrorBasic.vue?vue&type=script&lang=js"
export * from "./ErrorBasic.vue?vue&type=script&lang=js"

import "./ErrorBasic.vue?vue&type=style&index=0&id=5f603e95&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f603e95"]])

export default __exports__